
const BASE_URL = 'https://f2fl3xamwg.execute-api.ap-southeast-1.amazonaws.com';

const OrderService = {
  getOrders: async (view, type = 'All') => {
    try {
      const url = new URL(`${BASE_URL}/orders`);
      url.searchParams.append('view', view);
      if (type !== 'All') {
        const typeMapping = {
          'Dine-In': 'DINE_IN',
          'Take Away': 'TAKE_AWAY',
          'Delivery': 'DELIVERY'
        };
        const apiType = typeMapping[type] || type;
        url.searchParams.append('type', apiType);
      }

      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.data || [];
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      return [];
    }
  }
};

export default OrderService;
